@if (scpiType === 'FREE') {
  <product-form></product-form>
}
@if (scpiType != 'FREE') {
  <simulation-packs-scpi></simulation-packs-scpi>
}
